import React, { Component } from 'react';
import { Image } from 'react-bootstrap';
import './Home.css';

class Home extends Component {
  render() {
    return (
      <div className='home-banner-group'>
        <Image src={require("../assets/home-banner.jpg")} className='home-banner-image' />
        <div className='home-banner-text'>
          <h2>Welcome to Megadigm<span className="trademark">&reg;</span></h2>
          <h6>Power your AI and IoT smarts in realtime</h6>
        </div>
      </div>
    );
  }
}

export default Home;